import React, { useState } from "react";
import { Link } from "react-router-dom";
import useAuth from "../../hooks/auth/useAuth";
import "../../assets/css/login.css";

const NODE_COUNT = 42;
const ALERT_EVERY = 7;

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const { forgotPassword, message, error, loading } = useAuth();

  const logo = require("../../assets/images/logo/logo.png");

  const handleSubmit = async (e) => {
    e.preventDefault();
    await forgotPassword(email);
  };

  const feedback = error
    ? { type: "danger", text: error }
    : message
      ? { type: "success", text: message }
      : null;

  return (
    <div className="login-screen">
      {/* ---- Fond : grille de signaux surveillés ---- */}
      <div className="login-nodes" aria-hidden="true">
        <div className="login-nodes-sweep"></div>
        {Array.from({ length: NODE_COUNT }).map((_, i) => (
          <span
            key={i}
            className={`login-node${
              i % ALERT_EVERY === 0 ? " login-node--alert" : ""
            }`}
          />
        ))}
      </div>

      <div className="login-stage">
        {/* ---- Pitch ---- */}
        <div className="login-pitch">
          <div className="login-brand">
            <img src={logo} alt="SpyTeam" className="login-brand-logo" />
            <span className="login-brand-name">SpyTeam</span>
          </div>

          <span className="login-eyebrow">Récupération de compte</span>
          <h1 className="login-headline">
            Un accès coupé
            <br />
            n'est pas une visibilité perdue.
          </h1>
          <p className="login-subtext">
            Indiquez l'adresse liée à votre compte : nous vous envoyons un lien
            sécurisé pour définir un nouveau mot de passe.
          </p>

          <div className="login-status">
            <span className="login-status-dot"></span>
            Système en ligne
          </div>
        </div>

        {/* ---- Carte ---- */}
        <div className="login-card">
          <div className="login-card-header d-lg-none">
            <img src={logo} alt="SpyTeam" className="login-brand-logo" />
            <span className="login-brand-name">SpyTeam</span>
          </div>

          <h2 className="login-title">Mot de passe oublié</h2>
          <p className="login-lead">
            Entrez votre adresse e-mail, un lien de réinitialisation vous sera
            envoyé.
          </p>

          <form onSubmit={handleSubmit} noValidate>
            <div className="login-field">
              <label htmlFor="forgot-email">Adresse email</label>
              <input
                id="forgot-email"
                type="email"
                name="email"
                placeholder="vous@entreprise.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                autoComplete="email"
              />
            </div>

            {feedback && (
              <div className={`login-alert login-alert--${feedback.type}`}>
                {feedback.text}
              </div>
            )}

            <button className="login-submit" type="submit" disabled={loading}>
              {loading ? (
                <span
                  className="spinner-border spinner-border-sm"
                  role="status"
                />
              ) : (
                "Envoyer le lien"
              )}
            </button>

            <Link className="login-back" to="/login">
              ← Retour à la connexion
            </Link>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
